import { useEppo } from '@/composables/eppo'

import { FEATURE_FLAGS } from '@/lib/consts.js'

import { isObservedDaysWithinDateRange } from './is-observed-days-within-date-range.js'
import { getSurroundingWeeksRange } from './get-surrounding-weeks-range.js'
import { FIRESTORE_WEEKS_RANGE } from '../../consts.js'

import { isCalendarFirestoreReady } from '../../is-ready.js'

export const isFirestoreSupportedForSelectedDays = (days) => {
  if (!isCalendarFirestoreReady.value) return

  const eppo = useEppo()

  if (!eppo.ff(FEATURE_FLAGS.Feature_ProviderFirestore)
    || !eppo.ff(FEATURE_FLAGS.Feature_CalendarFirestoreIntegration)
  ) return false

  return isObservedDaysWithinDateRange(
    days,
    getSurroundingWeeksRange(FIRESTORE_WEEKS_RANGE)
  )
}
